import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import WhatsappConnectionsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-connections'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'whatsapp_connections_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'whatsapp_connections_list',
          component: WhatsappConnectionsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
